import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';
import DLink from '../../pieces/DLink';
export default function InstallLaeyerz() {

    return (
        <div>
            <DHeader>Installing Laeyerz</DHeader>
       
            <DText>
            Laeyerz is open-source and is hosted on github at  <DLink to="https://github.com/pixagan/laeyerz" target="_blank" rel="noopener noreferrer">https://github.com/pixagan/laeyerz</DLink>.
            The core Laeyerz repository is primarly the workflow engine.
            </DText>
            <DText>
            Clone the repository and install the dependencies.
            </DText>
            
            <DCode>
                {`git clone https://github.com/pixagan/laeyerz.git
cd laeyerz
pip install -r requirements.txt
                `}
            </DCode>

            

            <DText>
             To speed up development, we are adding connectors to select API platforms.
             These are primarily connectors to LLMs, Vector Stores and Databases. These are available in the laeyerz-nodes git repository.
            </DText>

            <DCode>
                {`git clone https://github.com/pixagan/laeyerz-nodes.git
                `}
            </DCode>
       
        </div>
    )
}